<template lang="pug">
article.blog-post
  template(v-if="loading")
    .blog-post__thumbnail.clp
    .blog-post__info
      .blog-post__metas
        .blog-post__category.clp.w-2 &nbsp;
        .blog-post__mins.clp.w-2 &nbsp;
      .blog-post__title.clp.w-8 &nbsp;
      .blog-post__summary.clp.w-10 &nbsp;
      .blog-post__more.clp.w-3 &nbsp;

  template(v-else)
    nuxt-link.blog-post__thumbnail(
      v-image="thumbnail"
      :to="to"
      :title="fields.title")
    .blog-post__info
      .blog-post__metas
        nuxt-link.blog-post__category(
          v-if="fields.category"
          :to="{ name: 'blog', query: { category: fields.category } }"
          :title="fields.category"
          v-text="fields.category")
        .blog-post__mins {{ content | minsRead }}
      nuxt-link.blog-post__title(
        :to="to"
        :title="fields.title"
        v-text="fields.title")
      .blog-post__summary(
        v-text="fields.summary")
      nuxt-link.blog-post__more(
        :to="to"
        :title="fields.title") Read more →
</template>

<script>
export default {
  scrollToTop: true,

  props: {
    entry: {
      type: Object,
      default: () => ({})
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    fields () {
      return this.entry.fields || {}
    },

    thumbnail () {
      return this.fields.thumbnail?.fields?.file?.url
    },

    to () {
      return {
        name: 'blog-slug',
        params: {
          slug: this.fields.slug
        }
      }
    },

    content () {
      return this.$contentful.html(this.fields.content)
    }
  }
}
</script>

<style lang="scss" scoped>
.blog-post {
  &__thumbnail {
    display: block;
    width: 100%;
    height: 0;
    padding-bottom: calc(100% / 16 * 9);
    background: $--color-placeholder;
    border-radius: 16px;
    background-size: cover;
    background-position: center;
  }
  &__metas {
    display: flex;
    margin: 1rem 0;
    gap: 1rem;
    align-items: center;
    > * {
      min-width: 0;
    }
  }
  &__category {
    background: $--color-highlight;
    color: $--color-text-regular;
    border-radius: $--radius;
    font-size: 13px;
    padding: .2em .5em;
  }
  &__mins {
    color: $--color-text-secondary;
  }
  &__title {
    font-size: 1.5rem;
    line-height: 150%;
    display: block;
    margin: .5em 0;
  }
  &__summary {
    color: $--color-text-secondary;
    font-size: 16px;
    line-height: 150%;
    margin: .5em 0;
  }
  &__more {
    display: block;
    margin: .75em 0;
    color: $--color-primary;
  }
}
</style>
